import React, { useEffect } from "react";
import LoyaltyTerms from "../../components/LoyaltyTerms";

import { usePageTransition } from "../../services/hooks/usePageTransition";

export default function loyaltyTerms() {
  const { startTransition, completeTransition } = usePageTransition();

  useEffect(() => {
    completeTransition();

    return () => {
      startTransition();
    };
  }, []);

  return <LoyaltyTerms />;
}
